import React from 'react';
import Button, { ButtonGroup } from '@atlaskit/button';
import { iLabelValuePair } from '../../../shared/UITypes/ui.types';
import { statusSelectorStyle } from '../../../shared/styles/styles';

const TypeFilter = ({
  options,
  selectedTypes,
  onSelectJobType,
}: {
  options: Array<iLabelValuePair>;
  selectedTypes: Array<string>;
  onSelectJobType: (select: string) => void;
}) => {
  return (
    <ButtonGroup>
      {options.map((type: iLabelValuePair) => {
        return (
          <Button
            className={selectedTypes.includes(type.value) ? 'selected' : ''}
            key={`job-type-${type.label}`}
            isSelected={selectedTypes.includes(type.value)}
            onClick={() => onSelectJobType(type.value)}
            testId={`job-type-${type.label}`}
            style={statusSelectorStyle}
          >
            {type.label}
          </Button>
        );
      })}
    </ButtonGroup>
  );
};

export default TypeFilter;
